import React from 'react';
import { withTranslation } from 'react-i18next';
import ImgIconComp from '../../../../components/imgcomp';
import { WbEventHandlerMixins, WbMarkdownHtml } from '../../../../utils/common';
import { type WithTranslation } from '../../../types/common.types';
import { AiCommentsProps } from '../../../types/sidePanel.types';
import moment from 'moment';

export default withTranslation()(class AiCommentsComp extends React.Component<WithTranslation<AiCommentsProps>> {
  constructor(props: WithTranslation<AiCommentsProps>) {
    super(props);
    this.splitCharAt = this.splitCharAt.bind(this);
    this.extractLastTerm = this.extractLastTerm.bind(this);
    this.registerAutoComplete = this.registerAutoComplete.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateCurrCmt = this.updateCurrCmt.bind(this);
    this.submitComment = this.submitComment.bind(this);
  }

  componentDidMount() {
    setTimeout(() => this.registerAutoComplete(), 100);
  }

  splitCharAt(val: string) {
    return val.split(/@/);
  }

  extractLastTerm(term: any) {
    return this.splitCharAt(term).pop();
  }

  registerAutoComplete() {
    const _this = this;
    ($(_this.refs.wsBoardAiCmtEditor) as any)
      .autocomplete({
        source(request: { term: any; }, response: (arg0: {}) => void) {
          const { term } = request;
          let results = [];
          var splitValue = _this.splitCharAt(term);
          //resetAtMentionUserData(splitValue, _this.refs.wsBoardAiCmtEditor); 
          const lastTerm = _this.extractLastTerm(term);
          if (
            term.indexOf("@") >= 0 &&
            term.slice(-1).indexOf(" ") == -1 &&
            lastTerm.length >= 2
          ) {
            $.ajax({
              type: "GET",
              url: `${wbConfig.baseUrl}/workboard/getRelatedMembers`,
              data: { term: lastTerm , 'viaAI' : true, includeOwnAgents: true }
            }).done(res => {
              if (res) {
                results = JSON.parse(res);
                if (results.length > 0) {
                  response(results);
                } else {
                  response({});
                }
              } else {
                response({});
              }
            });
          } else {
            response({});
          }
        },
        select(event: any, ui: any) {
          const cmtValue = $(_this.refs.wsBoardAiCmtEditor).html();
          const terms = _this.splitCharAt(cmtValue);
          terms.pop()
          addAtMentionSpan(terms, $(_this.refs.wsBoardAiCmtEditor), ui);
          WbEventHandlerMixins.placeCaretAtEnd(
            $(_this.refs.wsBoardAiCmtEditor).get(0)
          );
          return false;
        },
        focus() {
          return false;
        },
        open(event: any, ui: any) {
          $(this)
            .data("ui-autocomplete")
            .menu.element.addClass("board-cmt-mention-autocomplete");
        }
      })
      .data("ui-autocomplete")._renderItem = function (ul: string | Element | DocumentFragment | JQuery<HTMLElement> | (Element | DocumentFragment)[], item: { picSrc: string; label: string; }) {
        return $("<li></li>")
          .data("item.autocomplete", item)
          .append(
            `${"<a style='padding-left: 0 !important; margin-left: 0 !important;'>" +
            "<div class='displayRow-tmp' data-testid='displayRow-tmp' style='width: 80% !important; padding: 5px;'>" +
            "<div class='displayCell' data-testid='displayCell' style='vertical-align: middle;'>" +
            "<img data-testid='img' class='img-flag img-valign roundFramePhoto fitProfileImage' src='"}${
              item.picSrc  != '' ? item.picSrc : '../images/icons/menu/topnavigation/teams_new.png'
            }' width='20px' height='20px' />` +
            "</div>" +
            `<div class='displayCell ownerText'>${item.label}</div>` +
            "</div>" +
            "</a>"
          )
          .appendTo(ul);
      };
  }

  handleChange(event: any) {
    WbEventHandlerMixins.descAutoHeight($(".wsBoardAiCommentEditor"));
  }

  updateCurrCmt(event: { target: any; }) {
    const commentVal = $(event.target).html();
    this.props.updCurrCmt(commentVal);
  }

  submitComment() {
    const _this = this;
    const rawValue = $(_this.refs.wsBoardAiCmtEditor).html();

    if (!rawValue || rawValue == "") {
      return;
    }

    const value = WbEventHandlerMixins.replaceLinkWithAnchor(rawValue);
    let mentionedUserIds = getAtMentionUserIds($(_this.refs.wsBoardAiCmtEditor));
    let mentionedTeamIds = getAtMentionTeamIds($(_this.refs.wsBoardAiCmtEditor));
    $(_this.refs.wsBoardAiCmtEditor).html("");
    let mentionedTeamId = mentionedTeamIds.join(",");
    const hiddenUserIdVal = mentionedUserIds.join(',');
    this.props.addComment(value, hiddenUserIdVal, mentionedTeamId);
    $(_this.refs.wsBoardHiddenAiUserId).val("");
    WbEventHandlerMixins.descAutoHeight($(".wsBoardAiCommentEditor"));
  }

  render() {
    const { t } = this.props;
    return (
      <div className="wsBoardAiCommentsWrapper">
        <div data-testid="wsBoardCommentEditorWrapper tAc" className="wsBoardCommentEditorWrapper tAc">
          <div className="">
            <div
            data-testid="wsBoardAiCommentEditor"
              className="wsBoardAiCommentEditor"
              ref="wsBoardAiCmtEditor"
              //@ts-expect-error
              placeholder={t("Add a comment")}
              contentEditable="true"
              onKeyPress={this.handleChange}
            />
            <input
              type="hidden"
              ref="wsBoardHiddenAiUserId"
              name="wsBoardHiddenAiUserId"
            />
            <input type="hidden" value='' id="mentionUserIds" />
          </div>
          <div className="wsBoardCommentPost"  data-testid="wsBoardCommentPost">
            <button
              className="gbl-btn gbl-btn-slim wsBoardCommentPost"
              onClick={this.submitComment}
            >
              {t("Post")}
              </button>
          </div>
        </div>
        <div className="wsBoardCommentDiv" id="wsBoardCommentDiv">
          {this.props.aiComments != null &&
            Object.keys(this.props.aiComments).length
            ? Object.keys(this.props.aiComments).map((item: any, index) => (
              <WsBoardCommentListComp
                key={this.props.aiComments[item].id}
                comment={this.props.aiComments[item]}
                {...this.props}
              />
            ))
            : ""}
        </div>
      </div>
    );
  }
});

class WsBoardCommentListComp extends React.Component<WithTranslation<AiCommentsProps>, { showCmtEditBtns: boolean }> {
  constructor(props: WithTranslation<AiCommentsProps>) {
    super(props);
    this.state = {
      showCmtEditBtns: false
    };
    this.splitCharAt = this.splitCharAt.bind(this);
    this.extractLastTerm = this.extractLastTerm.bind(this);
    this.registerAutoComplete = this.registerAutoComplete.bind(this);
    this.editCmt = this.editCmt.bind(this);
    this.cancelCmtEdit = this.cancelCmtEdit.bind(this);
    this.showCmtEdit = this.showCmtEdit.bind(this);
    this.mouseover = this.mouseover.bind(this);
    this.mouseout = this.mouseout.bind(this);
  }

  splitCharAt(val: string) {
    return val.split(/@/);
  }

  extractLastTerm(term: any) {
    return this.splitCharAt(term).pop();
  }

  registerAutoComplete() {
    const _this = this;
    ($(_this.refs.wsBoardAiCmtEditEditor) as any)
      .autocomplete({
        source(request: { term: any; }, response: (arg0: any) => void) {
          let { term } = request;
          let results = [];
          if (term.indexOf("@") >= 0 && term.slice(-1).indexOf(" ") == -1) {
            term = _this.extractLastTerm(term);
            if (term.length >= 2) {
              $.ajax({
                type: "GET",
                url: `${wbConfig.baseUrl}/workboard/getRelatedMembers`,
                data: { term, includeOwnAgents: true }
              }).done(res => {
                if (res) {
                  results = JSON.parse(res);
                  response(results);
                }
              });
            }
          }
        },
        select(event: any, ui: { item: { label: any; value: any; }; }) {
          const cmtValue = $(_this.refs.wsBoardAiCmtEditEditor).html();
          const terms = _this.splitCharAt(cmtValue);
          const userIdVal: any = $(_this.refs.wsBoardHiddenAiUserId).val();
          let newVal = null;
          terms.pop();
          const tmpNameVal = ui.item.label;
          terms.push(tmpNameVal);
          $(_this.refs.wsBoardAiCmtEditEditor).html(terms.join("@"));
          if ($.trim(userIdVal).length != 0) {
            newVal = `${userIdVal},${ui.item.value}`;
          } else {
            newVal = ui.item.value;
          }
          $(_this.refs.wsBoardHiddenAiUserId).val(newVal);
          WbEventHandlerMixins.placeCaretAtEnd(
            $(_this.refs.wsBoardAiCmtEditEditor).get(0)
          );
          return false;
        },
        focus() {
          return false;
        },
        open(event: any, ui: any) {
          $(this)
            .data("ui-autocomplete")
            .menu.element.addClass("board-cmt-mention-autocomplete");
        }
      })
      .data("ui-autocomplete")._renderItem = function (ul: string | Element | DocumentFragment | JQuery<HTMLElement> | (Element | DocumentFragment)[], item: { picSrc: string; label: string; }) {
        return $("<li></li>")
          .data("item.autocomplete", item)
          .append(
            `${"<a style='padding-left: 0 !important; margin-left: 0 !important;'>" +
            "<div class='displayRow-tmp'  data-testid='displayRow-tmp' style='width: 80% !important; padding: 5px;'>" +
            "<div class='displayCell' data-testid='displayCell'  style='vertical-align: middle;'>" +
            "<img data-testid='img' class='img-flag img-valign roundFramePhoto fitProfileImage' src='"}${
            item.picSrc
            }' width='20px' height='20px' />` +
            "</div>" +
            `<div class='displayCell ownerText'>${item.label}</div>` +
            "</div>" +
            "</a>"
          )
          .appendTo(ul);
      };
  }

  editCmt(commentId: any, cmtOwnerAccess: any) {
    const _this = this;
    let updCmtVal = $(_this.refs.wsBoardAiCmtEditEditor)
      .html()
      .trim();
    if (updCmtVal && updCmtVal != "") {
      updCmtVal = WbEventHandlerMixins.replaceLinkWithAnchor(updCmtVal);
      this.setState({
        showCmtEditBtns: false
      });
      this.props.editComment(commentId, cmtOwnerAccess, updCmtVal);
    }
  }

  cancelCmtEdit() {
    this.setState({ showCmtEditBtns: false });
  }

  showCmtEdit(cmtOwnerAccess: any) {
    if (!cmtOwnerAccess) {
      return;
    }
    const _this = this;
    this.setState({ showCmtEditBtns: true });
    setTimeout(() => {
      _this.registerAutoComplete();
      WbEventHandlerMixins.descAutoHeight($(".wsBoardAiCommentEditEditor"));
    }, 100);
  }

  mouseover(cId: any) {
    $(".commentEdit").hide();
    $(`.wbCommentId_${cId}`).show();
  }

  mouseout(cId: any) {
    $(".commentEdit").hide();
  }

  render() {
    const { comment, ownerAccess, loggedInUserId = 0, t } = this.props;
    const cmtOwnerAccess = ownerAccess || loggedInUserId == comment.owner;
    const cmtEditPer = loggedInUserId == comment.owner;
    const commentClass = `wbCommentId_${comment.id}`;
    let create_at = ""; // (comment.create_at) ? moment.unix(comment.create_at).format("hh:mm a MMM DD, YYYY") : "" ;
    if (comment.create_at) {
      let _timestamp = parseInt(comment.create_at);
      const _userOffset =
        this.props.board.user.currentDate.userOffset || 0;
      if (typeof _userOffset !== "undefined" && _userOffset !== null) {
        _timestamp += parseInt(_userOffset);
      }
      create_at = moment.utc(_timestamp * 1000).format("hh:mm a MMM DD, YYYY");
    }
    return (
      <div className="wsBoardCommentListDiv">
        <div className="displayTable w100">
          <div className="displayRow">
            <div
              className="displayCell"
              onMouseOver={() => this.mouseover(comment.id)}
              onMouseOut={e => this.mouseout(comment.id)}
            >
              <ImgIconComp
                class="roundFramePhoto vAlignM fitProfileImage"
                srcUrl={comment.ownerImage}
                width="30"
                height="30"
              />
              <div
                className="displayInlineB wsBoardCommenterName truncateText"
                title={`${comment.firstname} ${comment.lastname}`}
              >
                {`${comment.firstname} ${comment.lastname}`}
              </div>
              <div className="displayInlineB commentDot" />
              <div className="displayInlineB pL10 wsBoardCommentDate">
                {create_at}
              </div>
              <span
                className={`${commentClass} commentEdit`}
                style={{ display: "none" }}
              >
                <div
                  className={`displayInlineB pL10 wsBoardCommentEdit clickable ${
                    cmtEditPer == false ? "hide" : ""
                    }`}
                  data-perm-value={cmtOwnerAccess}
                  onClick={() => this.showCmtEdit(cmtOwnerAccess)}
                >
                  <ImgIconComp id="edit_image" width="10" height="10" />
                </div>
                <div
                  className={`displayInlineB pL10 wsBoardCommentDel clickable ${
                    cmtOwnerAccess == false ? "hide" : ""
                    }`}
                  data-perm-value={cmtOwnerAccess}
                  onClick={() =>
                    this.props.removeCommentFromList(comment.id, cmtOwnerAccess)
                  }
                >
                  <ImgIconComp id="close_image" width="10" height="10" />
                </div>
              </span>
            </div>
          </div>
          <div className="displayRow">
            <div className="displayCell wsBoardCommentText">
              {!this.state.showCmtEditBtns && (
                <div
                  dangerouslySetInnerHTML={WbMarkdownHtml(comment.comment)}
                />
              )}
              {this.state.showCmtEditBtns && (
                <div
                  className="wsBoardAiCommentEditEditor"
                  ref="wsBoardAiCmtEditEditor"
                  onKeyPress={() =>
                    WbEventHandlerMixins.descAutoHeight(
                      $(".wsBoardAiCommentEditEditor")
                    )
                  }
                  contentEditable="true"
                  dangerouslySetInnerHTML={WbMarkdownHtml(comment.comment)}
                />
              )}
            </div>
          </div>
          {this.state.showCmtEditBtns && (
            <div className="displayRow">
              <div className="displayCell wsBoardCommentEdit">
                <div
                  className="displayInlineB gbl-btn gbl-btn-slim gbl-btn-cancel wsBoardCmtEditCancel"
                  onClick={() => this.cancelCmtEdit()}
                >
                  {t("Cancel")}
                </div>
                <div
                  className="displayInlineB gbl-btn gbl-btn-slim wsBoardCmtEditAdd"
                  onClick={() => this.editCmt(comment.id, cmtOwnerAccess)}
                >
                  {t("Add")}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
